import type {
  AcquisitionRestMethods,
  AcquisitionRestParams,
  AcquisitionRestResponse,
} from '@backend/app-acquisition-types';

import { getJobsBusinessUnitApiAcquisitionUrl } from '~/config';

export const callAcquisitionApiProxy = async <Method extends AcquisitionRestMethods>({
  body,
  businessUnit,
  method,
}: AcquisitionRestParams<Method> extends undefined
  ? {
      body?: undefined;
      businessUnit: string;
      method: Method;
    }
  : {
      body: NonNullable<AcquisitionRestParams<Method>>;
      businessUnit: string;
      method: Method;
    }) => {
  const url = getJobsBusinessUnitApiAcquisitionUrl(businessUnit, method);

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Error on acquisition call ${String(method)} for BU ${businessUnit}, status: ${response.status}`);
  }

  return (await response.json()) as AcquisitionRestResponse<Method>;
};
